import { DEFAULT_PAGE_SIZE } from '@/constants'
import { Web3SignPaginationModel, GetWeb3SignerRecordDTO } from './models'
import TxRecordBaseApi from './base'

class TxRecordApi extends TxRecordBaseApi {
  async getWeb3SignRecords(dto: GetWeb3SignerRecordDTO) {
    return this.post<Web3SignPaginationModel>('/signTx/queryTxByPage', {
      pageSize: DEFAULT_PAGE_SIZE,
      ...dto,
    })
  }
  async getSmallAmountConfig() {
    return this.post<string>('/tx/getSmallAmountConfig')
  }
}

export default new TxRecordApi()
